export default __webpack_public_path__ + "static/media/user.2881d877.png";